import { render, staticRenderFns } from "./LoanButtons.vue?vue&type=template&id=f2c4f9a4&scoped=true"
import script from "./LoanButtons.vue?vue&type=script&lang=js"
export * from "./LoanButtons.vue?vue&type=script&lang=js"
import style0 from "./LoanButtons.vue?vue&type=style&index=0&id=f2c4f9a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c4f9a4",
  null
  
)

export default component.exports